<template>
  <div>
    <add-edit-campaign-dialog
      @disableDialog="disableDialog"
      @resetFrm="resetFrm"
      @switchTitleStatusDialog="switchTitleStatusDialog"
      @addCampaignMarketing="addCampaignMarketing"
      @editCampaignMarketing="editCampaignMarketing"
      :isToggleDialogCampaign="dialogAddCampaign"
      :baseForm="forms"
      :editIndex="editIndex"
      :storeList="storeList"
      :isLoading="isLoading"
    />
    <show-store-dialog
      @disableShowStoreDialog="disableShowStoreDialog"
      :showStoreDialog="showStoreDialog"
      :storeProps="storeProps"
      :storeList="storeList"
    ></show-store-dialog>
    <h2 class="text-xs-center">Campaign Distance</h2>
    <v-layout row warp text-xs-right>
      <v-flex xs12>
        <v-btn color="yellow" @click="addCampaign" large>
          <v-icon color="black">add_circle_outline</v-icon>เพิ่มรายการ
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :loading="isTableLoading"
      :headers="headers"
      :items="campaignList"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ campaignList.indexOf(props.item) + 1 }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_th }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_en }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_cn }}</td>
        <td class="text-xs-center">{{ props.item.dm_start }}</td>
        <td class="text-xs-center">{{ props.item.dm_end }}</td>
        <td class="text-xs-center">{{ props.item.dm_price }}</td>
        <td class="text-xs-center">{{ props.item.dm_minimum }}</td>
        <td class="text-xs-center">
          <v-btn @click="showStoreDetail(props.item.dm_store)" icon>
            <v-icon color="black" small>remove_red_eye</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">{{ props.item.dm_time_start }}</td>
        <td class="text-xs-center">{{ props.item.dm_time_end }}</td>
        <td class="text-xs-center">
          <v-switch
            @change="onStatusItemChange(props.item)"
            v-model="props.item.dm_status"
            color="green"
          ></v-switch>
        </td>
        <td class="text-xs-center">
          <v-btn @click="editCampaign(props.item)" icon>
            <v-icon color="black" small>edit</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn @click="deleteCampaign(props.item)" icon>
            <v-icon color="black" small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import AddEditCampaignDialog from "@/components/back-office/CampaignDistance/AddEditCampaignDialog.vue";
import ShowStoreDialog from "@/components/back-office/CampaignDistance/ShowStoreDialog.vue";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "CampaignDistance",

  components: {
    "add-edit-campaign-dialog": AddEditCampaignDialog,
    "show-store-dialog": ShowStoreDialog,
  },

  data() {
    return {
      forms: this.getInitialForm(),
      search: "",
      isLoading: true,
      showStoreDialog: false,
      isTableLoading: "black",
      editIndex: -1,
      storeProps: [],
      dialogAddCampaign: false,
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        { text: "No", align: "center", sortable: false, value: "dm_name_th" },
        {
          text: "ชื่อแคมเปญ (TH)",
          align: "center",
          sortable: false,
          value: "dm_name_th",
        },
        {
          text: "ชื่อแคมเปญ (ENG)",
          align: "center",
          sortable: false,
          value: "dm_name_en",
        },
        {
          text: "ชื่อแคมเปญ (CN)",
          align: "center",
          sortable: false,
          value: "dm_name_cn",
        },
        {
          text: "ระยะทางเริ่มต้น",
          align: "center",
          sortable: false,
          value: "dm_start",
        },
        {
          text: "ระยะทางสิ้นสุด",
          align: "center",
          sortable: false,
          value: "dm_end",
        },
        {
          text: "ส่วนลด (บาท)",
          align: "center",
          sortable: false,
          value: "dm_price",
        },
        {
          text: "ราคาขั้นต่ำ (บาท)",
          align: "center",
          sortable: false,
          value: "dm_minimum",
        },
        {
          text: "ร้านค้าที่ร่วมแคมเปญ",
          align: "center",
          sortable: false,
          value: "dm_store",
        },
        {
          text: "วัน/เวลา (เริ่มต้น)",
          align: "center",
          sortable: false,
          value: "dm_time_start",
        },
        {
          text: "วัน/เวลา (สิ้นสุด)",
          align: "center",
          sortable: false,
          value: "dm_time_end",
        },
        { text: "สถานะ", align: "center", sortable: false, value: "dm_status" },
        { text: "Edit", align: "center", sortable: false },
        { text: "Delete", align: "center", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState({
      campaignList: (state) => state.campaigns.campaignMarketingList,
      storeList: (state) => state.fetchStoreBack.store_list,
    }),

    province() {
      return this.$route.params.province;
    },
  },

  async created() {
    await Promise.all([this.getStoreList(), this.getCampaignList()]);
  },

  methods: {
    // Utility Methods
    moment,

    getInitialForm() {
      return {
        dm_name_th: "",
        dm_name_en: "",
        dm_name_cn: "",
        dm_start: "",
        dm_end: "",
        dm_time_start: "",
        dm_time_end: "",
        dm_price: "",
        dm_minimum: "",
        dm_status: true,
        dm_store: null,
        timestart: { HH: "", mm: "" },
        timeend: { HH: "", mm: "" },
        datestart: "",
        dateend: "",
      };
    },

    alertDialog(msg, status) {
      Swal.fire({
        position: "center",
        icon: status,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    // Dialog Management
    disableShowStoreDialog() {
      this.showStoreDialog = !this.showStoreDialog;
    },

    disableDialog() {
      this.dialogAddCampaign = false;
    },

    switchTitleStatusDialog() {
      this.editIndex = !this.editIndex;
    },

    addCampaign() {
      this.dialogAddCampaign = !this.dialogAddCampaign;
    },

    resetFrm() {
      this.forms = this.getInitialForm();
    },

    // Store Operations
    showStoreDetail(item) {
      this.storeProps = item;
      this.showStoreDialog = true;
    },

    // Campaign Operations
    async onStatusItemChange(item) {
      const rs = await this.$store.dispatch(
        "campaigns/changStatusCampaignMarketing",
        { item, province: this.province }
      );
      if (!rs) {
        item.dm_status = !item.dm_status;
      }
    },

    editCampaign(item) {
      this.dialogAddCampaign = true;
      const strStart = item.dm_time_start;
      const strEnd = item.dm_time_end;

      this.forms = {
        dm_id: item.dm_id,
        dm_name_th: item.dm_name_th,
        dm_name_en: item.dm_name_en,
        dm_name_cn: item.dm_name_cn,
        dm_start: item.dm_start,
        dm_end: item.dm_end,
        dm_time_start: "",
        dm_time_end: "",
        dm_price: item.dm_price,
        dm_minimum: item.dm_minimum,
        datestart: moment(strStart).format("YYYY-MM-DD"),
        timestart: {
          HH: moment(strStart).format("HH"),
          mm: moment(strStart).format("MM"),
        },
        dateend: moment(strEnd).format("YYYY-MM-DD"),
        timeend: {
          HH: moment(strEnd).format("HH"),
          mm: moment(strEnd).format("MM"),
        },
        dm_status: item.dm_status,
        dm_store: item.dm_store,
      };
      this.editIndex = 1;
    },

    async deleteCampaign(item) {
      const confirmed = await this.confirmDelete();
      if (confirmed) {
        const rs = await this.$store.dispatch(
          "campaigns/deleteCampaignMarketing",
          { item, province: this.province }
        );

        if (rs) {
          this.alertDialog("ลบข้อมูลเรียบร้อยแล้ว", "success");
        } else {
          this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
        }
      }
    },

    async confirmDelete() {
      const result = await Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบแคมเปญนี้หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก",
      });
      return result.isConfirmed;
    },

    // API Methods
    async getStoreList() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("fetchStoreBack/getStoreList");
      } catch (error) {
        this.alertDialog("เกิดข้อผิดพลาดในการโหลดข้อมูลร้านค้า", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async getCampaignList() {
      try {
        await this.$store.dispatch(
          "campaigns/getCampaignMarketing",
          this.province
        );
      } catch (error) {
        this.alertDialog("เกิดข้อผิดพลาดในการโหลดข้อมูลแคมเปญ", "error");
      } finally {
        this.isTableLoading = "null";
      }
    },

    async addCampaignMarketing(form) {
      const rs = await this.$store.dispatch("campaigns/addCampaignMarketing", {
        form,
        province: this.province,
      });

      if (rs.msg === true) {
        this.alertDialog("เพิ่มข้อมูลเรียบร้อยแล้ว", "success");
      } else {
        this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
      }
    },

    async editCampaignMarketing(item) {
      const rs = await this.$store.dispatch("campaigns/editCampaignMarketing", {
        item,
        province: this.province,
      });

      if (rs.msg === true) {
        this.alertDialog("แก้ไขข้อมูลเรียบร้อยแล้ว", "success");
      } else {
        this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
      }
    },
  },
};
</script>
